import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MdlModule } from './../lib/components';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { RegisterComponent } from './register/register.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { LoginService,RegisterService,UsersService,StudentService,
  UniversityService,SubjectService,SemesterService,FinanceService,ProductService,QusAnsService,ChapterService } from './service';
  import { AuthGuard } from './common/auth.guard';
import { CommonAppModule } from './common/common.module';
import { MatDialogModule } from '@angular/material';

@NgModule({
  imports: [
    BrowserAnimationsModule,MdlModule,CommonAppModule,
    FormsModule,ReactiveFormsModule,MatDialogModule,
    HttpModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    AngularFontAwesomeModule,
    NgbModule.forRoot()
  ],
  declarations: [
    AppComponent,LoginComponent,
    AdminLayoutComponent,RegisterComponent,ForgetPasswordComponent

  ],
  providers: [LoginService,FinanceService,RegisterService,UsersService,StudentService,AuthGuard,
    UniversityService,SubjectService,SemesterService,ProductService,QusAnsService,ChapterService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts